import { User } from 'api/models';

export const fullName = (user: Pick<User, 'firstName' | 'lastName'>): string =>
  [user?.firstName ?? '', user?.lastName ?? ''].join(' ').trim();
